<template>
  <AppConfirmationModal v-bind="$attrs" @input="$emit('input', $event)" persistent max-width="500px" :loading="loading">
    <template #title>{{ $t('WaterQualityReportErrorModal.titleMsg') }}</template>
    <template #text>
      <v-layout row wrap>
        <v-flex xs12 pb-4>{{ customTitle == null ? defaultTitle : customTitle }}</v-flex>
        <v-flex xs12>
          <v-expansion-panel v-if="itemLength ">
            <v-expansion-panel-content key="header" class="elevation-3">
              <template v-slot:header>
                <div>
                  {{ $t('WaterQualityReportErrorModal.errorMessage', { msg: pluralize('Message', itemLength) }) }}
                  <v-chip>{{ itemLength }}</v-chip>
                </div>
              </template>
              <v-expansion-panel>
                <template v-if="isUnhandledException">
                  <v-expansion-panel-content v-for="item in data" :key="item">
                    <template v-slot:header>
                      <span>{{ item }}</span>
                    </template>
                  </v-expansion-panel-content>
                </template>
                <template v-else>
                  <analyte-guideline-unit-mismatch-record-item v-if="hasAnalyteGuidelineUnitMismatchExceptionRecord" :itemData="data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors"></analyte-guideline-unit-mismatch-record-item>
                  <analyte-labResult-unit-mismatch-record-item v-if="hasAnalyteLabResultUnitMismatchExceptionRecord" :itemData="data.AnalyteLabResultUnitMismatchExceptionRecord.Errors"></analyte-labResult-unit-mismatch-record-item>
                </template>
              </v-expansion-panel>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <PrimaryBtn v-if="customTitle == null" color="warning" @click="_emitDownload">{{ $t('WaterQualityReportErrorModal.downloadAnyway') }}</PrimaryBtn>
      <SecondaryBtn @click="_emitCancel">{{ $t('Button.Close') }}</SecondaryBtn>
    </template>
  </AppConfirmationModal>
</template>

<script>
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import AnalyteLabResultUnitMismatchRecordItem from '@/components/generic/ErrorModalItem/AnalyteLabResultUnitMismatchRecordItem'
  import AnalyteGuidelineUnitMismatchRecordItem from '@/components/generic/ErrorModalItem/AnalyteGuidelineUnitMismatchRecordItem'
  import {
    pluralize,
    combineStringItem,
  } from '@/helpers/strings'
  export default {
    components: {
      'app-confirmation-modal': AppConfirmationModal,
      'analyte-labResult-unit-mismatch-record-item': AnalyteLabResultUnitMismatchRecordItem,
      'analyte-guideline-unit-mismatch-record-item': AnalyteGuidelineUnitMismatchRecordItem,
    },
    props: {
      data: {
        type: [Object, Array],
        default: () => {},
      },
      loading: {
        type: Boolean,
        default: false,
      },
      customTitle: {
        type: String,
        default: null,
      },
    },
    data() {
      return {}
    },
    computed: {
      isUnhandledException() {
        return !this.hasAnalyteLabResultUnitMismatchExceptionRecord && !this.hasAnalyteGuidelineUnitMismatchExceptionRecord
      },
      exceptionLength() {
        return this.isUnhandledException ? this.data.length : 0
      },
      hasAnalyteLabResultUnitMismatchExceptionRecord() {
        return !!this.data && !!this.data.AnalyteLabResultUnitMismatchExceptionRecord && this.data.AnalyteLabResultUnitMismatchExceptionRecord.HasErrors
      },
      hasAnalyteGuidelineUnitMismatchExceptionRecord() {
        return !!this.data && !!this.data.AnalyteGuidelineUnitMismatchExceptionRecord && this.data.AnalyteGuidelineUnitMismatchExceptionRecord.HasErrors
      },
      dataLength() {
        let AnalyteLabResultUnitMismatchExceptionRecordLength = this.hasAnalyteLabResultUnitMismatchExceptionRecord ? this.data.AnalyteLabResultUnitMismatchExceptionRecord.Errors.length : 0
        let AnalyteGuidelineUnitMismatchExceptionRecordLength = this.hasAnalyteGuidelineUnitMismatchExceptionRecord ? this.data.AnalyteGuidelineUnitMismatchExceptionRecord.Errors.length : 0
        return AnalyteLabResultUnitMismatchExceptionRecordLength + AnalyteGuidelineUnitMismatchExceptionRecordLength
      },
      defaultTitle() {
        if (this.isUnhandledException) {
          return this.$t('WaterQualityReportErrorModal.unexpectedErrorMsg', { message: `: ${this.data[0]}` })
        } else {
          return this.$t('WaterQualityReportErrorModal.customDescriptionMsg', { msg: pluralize('message', this.dataLength) }) + combineStringItem(this.parseError(this.data)) + '.'
        }
      },
      itemLength() {
        return this.dataLength > 0 ? this.dataLength : this.exceptionLength
      },
    },
    methods: {
      pluralize,
      parseError(error) {
        let msg = []
        if (this.hasAnalyteLabResultUnitMismatchExceptionRecord) {
          msg.push(pluralize('data point', error.AnalyteLabResultUnitMismatchExceptionRecord.Errors.length))
        }
        if (this.hasAnalyteGuidelineUnitMismatchExceptionRecord) {
          msg.push(pluralize('guideline value', error.AnalyteGuidelineUnitMismatchExceptionRecord.Errors.length))
        }
        return msg
      },
      _emitDownload() {
        this.$emit('download')
      },
      _emitCancel() {
        this.$emit('cancel')
      },
    },
    mounted() {},
  }
</script>

<style scoped>
  .error-detail-body {
    padding: 12px 24px;
  }
</style>